import { render, staticRenderFns } from "./solution2.vue?vue&type=template&id=63aa40b6&scoped=true"
import script from "./solution2.vue?vue&type=script&lang=js"
export * from "./solution2.vue?vue&type=script&lang=js"
import style0 from "./solution2.vue?vue&type=style&index=0&id=63aa40b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63aa40b6",
  null
  
)

export default component.exports